<template>
  <div class="p-wallet">
    <div class="g-header">
      <el-page-header @back="$router.go(-1)">
        <div slot="title">
          <i class="el-icon-arrow-left"></i>
          返回
        </div>
        <div slot="content">我的钱包 <i @click="getChatInfo" class="el-icon-refresh"></i></div>
      </el-page-header>
    </div>
    <div class="body">
      <el-card class="flex-box">
        <div class="left">
          <div class="title"><svg-icon style="fill: #333333;" name="bean"></svg-icon>我的能量豆</div>
          <div class="value">
            {{ beansNum }}
          </div>
          <p class="tip">
            <span>10个能量豆=1元</span>
            <el-button type="text" @click="ruleVisible = true">如何获得</el-button>
          </p>
          <el-button @click="fullVisible = true" type="warning">立即充值</el-button>
        </div>
        <div class="right">
          <div class="title"><i class="el-icon-coin"></i>我的现金</div>
          <div class="value">¥{{ balance }}</div>
          <el-button @click="drawmoneyHandle" type="success">立即提现</el-button>
        </div>
      </el-card>
      <div class="list">
        <div class="tool-box">
          <el-select size="mini" @change="changeHanlde()" v-model="selectValue" placeholder="请选择">
            <el-option label="能量豆" value="beansNum"> </el-option>
            <el-option label="现金流水" value="balance"> </el-option>
          </el-select>
          <el-date-picker size="mini" v-model="date" type="month" :clearable="false" @change="changeHanlde" placeholder="选择月份"> </el-date-picker>
        </div>
        <div v-if="totalCount === recordList.length && totalCount === 0">
          <el-divider>暂无账单记录</el-divider>
        </div>
        <ul class="scroll-box" ref="list" @scroll="scrollHandle">
          <li :class="['list-item', item.value > 0 ? 'add' : 'reduce']" v-for="(item, index) in recordList" :key="index">
            <p style="display: flex;flex-direction: column;">
              <span>
                <svg-icon name="bean" v-if="selectValue === 'beansNum'"></svg-icon>
                <svg-icon name="money" v-else-if="selectValue === 'balance'"></svg-icon>
                [{{ item.user }}]{{ item.txt }}
              </span>
              <span style="font-size: 12px; color: #999;">{{ item.time }}</span>
            </p>
            <span class="count">{{ Math.abs(item.value) }}</span>
          </li>
          <li>
            <el-divider v-if="totalCount && totalCount <= this.recordList.length">暂无更多记录</el-divider>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog title="能量豆" custom-class="rule-dialog" :visible.sync="ruleVisible" width="90%" top="5vh">
      <div class="rule-box">
        <p class="title">
          1.什么是能量豆
        </p>
        <p>能量豆是正能量ERP聊天室中用户参与好友互动给到的奖励。</p>
        <p class="title">2.如何获得能量豆</p>
        <p>
          在聊天室中可以与好友进行互动，对好友发送的信息进行点赞,评论的方式均可获得能量豆。如下图
        </p>
        <p style="color: #ee7700">
          (1).被点赞
          <img style="display: block" src="../assets/images/tip1.png" alt="" />
        </p>
        <p style="color: #ee7700">
          (2).回复/评论
          <img style="display: block" src="../assets/images/tip2.png" alt="" />
        </p>
        <p style="color: #ee7700">
          (3).充值，支持微信和支付宝线上支付,或联系客服人员协助
        </p>
        <p class="title">3.能量豆有什么用途</p>
        <p>
          可用于在聊天室中发布推广；招聘；求助和询价的信息进行抵扣，10个能量豆=1元。
        </p>
        <p class="title">4.能量豆抵扣的规则</p>
        <p>
          (1).每条求助信息 = 10个能量豆。<br />
          (2).每条招聘信息 = 10个能量豆。<br />
          (3).每条供应信息 = 10个能量豆。<br />
          (4).每条求购信息 = 10个能量豆。<br />
          发布成功后,系统将会从我的能量豆中进行抵扣掉。
        </p>
      </div>
    </el-dialog>
    <el-dialog title="充值" custom-class="dialog" :visible.sync="fullVisible" width="90%">
      <div class="full-box">
        <div class="packing">
          <div
            class="packing-item"
            v-for="(item, index) in packing"
            :key="index"
            @click="pricIndex = index"
            :style="{
              border: pricIndex === index ? '2px solid#ee7700' : '1px solid #CED0DA'
            }"
          >
            <div class="price">¥{{ item.price }}</div>
            <div class="attach">
              <span>{{ item.price * 10 }}个能量豆</span>
              <span class="beans">附赠{{ item.attach }}个</span>
            </div>
          </div>
        </div>
        <div class="input-number">
          <el-input v-model="buyNum" type="number" :min="1" :max="99">
            <template slot="prepend">购买数量</template>
          </el-input>
        </div>
        <div class="amount">
          <span
            ><span style="font-weight: bold;">合计:</span> <span class="price">¥ {{ amount.price }}</span></span
          >
          <span>{{ amount.number }}个能量豆</span>
        </div>
        <el-button @click="buy" type="warning">立即购买</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提现到微信" :visible.sync="atmVisible" width="90%">
      <div class="atm-content">
        <div class="wechat-info">
          <el-avatar :src="bindInfo.avatar"></el-avatar>
          <span>{{ bindInfo.name }}</span>
        </div>
        <div class="input-box">
          <el-input size="small" type="number" :disabled="true" :value="balance">
            <template slot="prepend">可提现金额</template>
          </el-input>
          <el-input size="small" type="number" min="1.00" :max="balance" step="0.01" v-model.number="drawMoney">
            <template slot="prepend">提现金额</template>
          </el-input>
          <el-button :loading="loading" @click="withdrawal" style="width: 100%" type="success">申请提现</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Utils from "@/utils";
import User from "@/api/user";
import Pay from "@/api/pay";
import { mapState, mapActions } from "vuex";
import Bus from "@/components/Bus";

export default {
  data() {
    return {
      info: {},
      buyBeansVisible: false,
      date: "",
      selectValue: "beansNum",
      ruleVisible: false,
      fullVisible: false,
      atmVisible: false,
      buyNum: 1,
      drawMoney: 0,
      loading: false,
      totalCount: -1,
      pageIndex: 1,
      recordList: [],
      bindInfo: {},
      packing: [
        {
          price: 500,
          attach: 400
        },
        {
          price: 1000,
          attach: 1000
        }
      ],
      pricIndex: 0
    };
  },
  computed: {
    ...mapState({
      beansNum: state => state.beansNum,
      balance: state => state.balance,
      token: state => state.token
    }),
    amount() {
      const reult = { number: 0, price: 0 };
      const select = this.packing[this.pricIndex];
      reult.number = (select.price * 10 + select.attach) * this.buyNum;
      reult.price = select.price * this.buyNum;
      return reult;
    }
  },
  watch: {
    token: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.getBillList();
          this.$store.dispatch("getChatInfo");
        }
      }
    }
  },
  methods: {
    ...mapActions(["getChatInfo"]),
    buy() {
      this.fullVisible = false;
      Pay.buyBeans(this.amount.price).then(res => {
        Bus.$emit("showPayQR", res.PayUrl);
      });
    },
    more() {
      this.pageIndex += 1;
      this.getBillList();
    },
    async withdrawal() {
      this.loading = true;
      await Pay.withdrawal(this.drawMoney)
        .then(() => {
          this.loading = false;
          this.$toast.success("已提交申请，请注意查收！");
          this.atmVisible = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async drawmoneyHandle() {
      // if (this.balance < 1) {
      //   this.$toast.fail("提现的余额必须大于1元！");
      //   return false;
      // }
      await User.getWeChatInfo().then(res => {
        if (res.OpenId) {
          this.drawMoney = res.MyBalance;
          this.bindInfo = {
            account: res.Account,
            avatar: res.AvatarUrl,
            openId: res.OpenId,
            userName: res.UserName,
            name: res.WechatAlias
          };
        } else {
          this.$toast.fail("请先绑定微信！");
          return false;
        }
      });
      this.drawMoney = this.balance;
      this.atmVisible = true;
    },
    async getBillList() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      if (this.selectValue === "balance") {
        await User.balanceList({
          date: this.date,
          pageIndex: this.pageIndex
        }).then(response => {
          this.totalCount = response.TotalCount;
          response.ResultList.map(item => {
            this.totalCount = response.TotalCount;
            this.recordList.push({
              value: item.Money,
              txt: item.SourceTypeStr,
              time: item.TradeTime,
              user: item.UserName
            });
          });
        });
      } else {
        await User.beansList({
          date: this.date,
          pageIndex: this.pageIndex
        }).then(response => {
          this.totalCount = response.TotalCount;
          response.ResultList.map(item => {
            this.totalCount = response.TotalCount;
            this.recordList.push({
              value: item.Beans,
              txt: item.SourceTypeStr,
              time: item.TradeTime,
              user: item.UserName
            });
          });
        });
      }
      this.$nextTick(() => (this.loading = false));
    },
    scrollHandle(e) {
      const target = e.target;
      if (target.scrollTop + target.offsetHeight > target.scrollHeight - 100 && !this.loading) {
        if (this.recordList.length < this.totalCount) {
          this.more();
        }
      }
    },
    changeHanlde(event) {
      if (event) {
        this.date = Utils.getNowMonth(event);
      }
      this.pageIndex = 1;
      this.loading = false;
      this.totalCount = -1;
      this.recordList = [];
      this.getBillList();
    }
  },
  created() {
    this.date = Utils.getNowMonth();
  },
  mounted() {
    const { visible } = this.$route.query;
    if (visible) {
      this[`${visible}Visible`] = true;
    }
  }
};
</script>
<style lang="scss">
.p-wallet {
  .el-icon-refresh {
    cursor: pointer;
  }
  .el-divider {
    margin: 12px 0;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
    color: #4d4d4d;
  }
  .g-header {
    background-color: #f5f5f5;
    .el-page-header__content {
      font-size: 14px;
      color: #000;
    }
  }
  .el-page-header {
    .el-icon-back {
      display: none;
    }
  }
  .rule-dialog {
    .el-dialog__body {
      padding: 0 20px 20px;
    }
  }
  .dialog {
    border-radius: 4px;
    .el-icon-close {
      margin-top: -10px;
      font-size: 26px;
    }
    .el-dialog__header {
      font-weight: bold;
      font-size: 16px;
      color: #4d4d4d;
    }
  }
  .el-card,
  .flex-box > .el-card__body {
    display: flex;
    width: 100%;
    > div {
      width: 50%;
    }
    .left {
      padding-right: 20px;
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      border-right: 1px solid #eee;
    }
    .right {
      display: inline-flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 20px;
      .value {
        font-size: 32px;
        margin-bottom: 40px;
      }
    }
    .title {
      margin-bottom: 16px;
    }
    .el-button {
    }
  }
  .full-box {
    .input-number {
      .el-input {
        margin-bottom: 0;
      }
      .el-input-group__prepend {
        padding: 0 26px;
        color: #999;
        background-color: #f0f3f8;
      }
      input {
        height: 36px;
        text-align: center;
      }
    }
    .packing-item {
      margin-bottom: 10px;
      padding: 10px;
      display: flex;
      border: 1px solid #eee;
      align-items: center;
      justify-content: space-between;
      border-radius: 4px;
      .price {
        font-size: 24px;
        color: #ee7700;
        font-weight: bold;
      }
      .attach {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        color: #000;
        .beans {
          color: #cc2200;
          font-size: 12px;
        }
      }
    }
    .amount {
      display: flex;
      flex-direction: column;
      padding-bottom: 24px;
      font-size: 14px;
      span {
        width: 100%;
        text-align: right;
        color: #000;
      }
      .price {
        font-size: 20px;
        color: #ee7700;
        margin-left: 10px;
        font-weight: bold;
      }
    }
    .el-button {
      width: 100%;
    }
  }
  .rule-box {
    height: 75vh;
    overflow: auto;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #000;
    }
    p {
      font-size: 14px;
      line-height: 24px;
      color: #4d4d4d;
      margin-bottom: 5px;
      img {
        width: 100%;
      }
    }
  }
  .info-box {
    display: flex;
    font-size: 12px;
    align-items: center;
    height: 40px;
    .el-avatar {
      width: 30px;
      height: 30px;
    }
    .text {
      padding-left: 10px;
      display: inline-block;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .body {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-top: 32px;
    height: 100vh;
    background: #f0f3f8;
    .el-card:first-child {
      flex-shrink: 0;
    }
    .tip {
      margin-top: -15px;
      font-size: 12px;
      white-space: nowrap;
      > span {
        color: #999;
      }
      .el-button {
        font-size: 12px;
        margin-left: 5px;
        color: #2288cc;
        text-decoration: underline;
      }
    }
  }
  .atm-content {
    margin: 0 auto;
    .input-box {
      > div {
        padding-bottom: 10px;
      }
    }
    .wechat-info {
      padding-bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .list {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 0px 20px;
    background-color: #fff;
    height: 100%;
    font-size: 14px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .el-date-editor {
      width: 100px;
      .el-input__inner {
        padding-right: 0;
      }
    }
    .tool-box {
      padding: 5px 0;
      display: flex;
      font-size: 14px;
      align-items: center;
      .el-select {
        margin-right: 10px;
        width: 100px;
      }
    }
  }
  .scroll-box {
    height: 100%;
    overflow: auto;
    svg {
      font-size: 16px;
    }
    li {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      &:nth-last-child(2) {
        border: none;
        padding-bottom: 0;
      }
      &:last-child {
        border: none;
      }
    }
    .reduce {
      color: #0f9321;
      .count:before {
        content: "-";
      }
    }
    .add {
      color: #cc2200;
      .count:before {
        content: "+";
      }
    }
  }
  .el-card {
    position: relative;
    .title {
      svg {
        margin-bottom: -3px;
        font-size: 16px;
      }
    }
    .el-button--success {
      background: #4caf50;
    }
    .el-button--warning {
      background: #ed9e00;
    }
    .value {
      display: flex;
      align-items: center;
      font-size: 30px;
      font-weight: bold;
    }
  }
}
</style>
